import { render, staticRenderFns } from "./Requesthistory.vue?vue&type=template&id=4842dabf"
import script from "./Requesthistory.vue?vue&type=script&lang=js"
export * from "./Requesthistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports